import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import congratulationsAnimation from '../Congratulations.json';
import Lottie from 'lottie-react';

const OfferModal = ({ show, onClose, mainPack, offerPack, makeOrder }) => {
  if (!show || !mainPack || !offerPack) return null;
  console.log(offerPack);

  const handlePrimaryClick = () => {
    console.log('Attempting to use offer pack:', offerPack);
    console.log('Offer pack ID:', offerPack.id);
    makeOrder(offerPack.id);

    onClose();
  };

  const handleSecondaryClick = () => {
    makeOrder(mainPack.id); // Make order with main pack
    onClose(); // Close the modal
  };

  return (
    <Overlay onClick={onClose}>
      <BottomSheet onClick={e => e.stopPropagation()}>
        <Handle />
        <Confetti>
          {[...Array(9)].map((_, i) => (
            <ConfettiPiece key={i} index={i} />
          ))}
        </Confetti>

        <Content>
          <FloatingEmojis>
            <FloatingEmoji>🎉</FloatingEmoji>
            <FloatingEmoji>✨</FloatingEmoji>
            <FloatingEmoji>💫</FloatingEmoji>
            <FloatingEmoji>🎊</FloatingEmoji>
          </FloatingEmojis>

          <Header>
            {/* <LottieWrapper>
    <FloatingLottie
      animationData={congratulationsAnimation}
      loop
      autoplay
    />
  </LottieWrapper> */}

            <Title>First‑Time Special, Just for You!</Title>
            <MotivationSub>
              ⏰ This exclusive offer won't last long
            </MotivationSub>
          </Header>

          <OfferCard onClick={handlePrimaryClick}>
            {/* <BestDeal>🏆 Best Deal</BestDeal> */}
            <OfferMain>🚀 Double the deal</OfferMain>

            <OfferDetail>
              Send {offerPack.songs || 2} requests and own the vibe
            </OfferDetail>
            <PriceSection>
              <NewPrice>₹{offerPack.price}</NewPrice>
            </PriceSection>
          </OfferCard>

          <Options>
            <PrimaryCTA onClick={handlePrimaryClick}>
              <Sparkle>✨</Sparkle> Claim Offer @ ₹{offerPack.price}
            </PrimaryCTA>

            <SecondaryCTA onClick={handleSecondaryClick}>
              No, Continue with {mainPack.coins / 100} song @ ₹{mainPack.price}
            </SecondaryCTA>
          </Options>
        </Content>
      </BottomSheet>
    </Overlay>
  );
};

// Animations

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const shimmerEffect = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

// Styled Components
const PrimaryCTA = styled.button`
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 16px;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(220, 38, 38, 0.4);
  width: 100%;
  margin-bottom: 12px;
  animation: ${pulse} 2s infinite;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(220, 38, 38, 0.5);
    animation: none;
  }

  &:active {
    transform: scale(0.95);
  }

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.1),
      transparent
    );
    transform: rotate(45deg);
    transition: all 0.3s ease;
  }

  &:hover::before {
    animation: ${shimmerEffect} 1.5s infinite;
  }
`;

const SecondaryCTA = styled.button`
  background: transparent;
  color: #92400e;
  padding: 16px 24px;
  border: 2px solid #d97706;
  border-radius: 16px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;

  &:hover {
    background: rgba(217, 119, 6, 0.1);
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const Sparkle = styled.span`
  color: #f59e0b;
  margin-right: 8px;
`;
const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

const confettiFall = keyframes`
  0% { transform: translateY(-100px) rotate(0deg); opacity: 1; }
  100% { transform: translateY(200px) rotate(360deg); opacity: 0; }
`;

const floatBounce = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  25% { transform: translateY(-8px) rotate(5deg); }
  50% { transform: translateY(-15px) rotate(0deg); }
  75% { transform: translateY(-8px) rotate(-5deg); }
`;

const pulseBounce = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
`;

const glowPulse = keyframes`
  0%, 100% { box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4); }
  50% { box-shadow: 0 8px 20px rgba(220, 38, 38, 0.6); }
`;

const cardGlow = keyframes`
  0%, 100% { box-shadow: 0 10px 30px rgba(220, 38, 38, 0.4); }
  50% { box-shadow: 0 15px 40px rgba(220, 38, 38, 0.6); }
`;

const shimmer = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const sparkle = keyframes`
  0%, 100% { transform: scale(1) rotate(0deg); opacity: 0.7; }
  50% { transform: scale(1.3) rotate(180deg); opacity: 1; }
`;

const priceBounce = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const optionGlow = keyframes`
  0%, 100% { box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3); }
  50% { box-shadow: 0 6px 16px rgba(245, 158, 11, 0.5); }
`;

const radioBounce = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const dealPulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
`;

const buttonPulse = keyframes`
  0%, 100% { box-shadow: 0 8px 20px rgba(220, 38, 38, 0.4); }
  50% { box-shadow: 0 12px 30px rgba(220, 38, 38, 0.6); }
`;

const coinSpin = keyframes`
  0%, 100% { transform: rotateY(0deg); }
  50% { transform: rotateY(180deg); }
`;

// Styled Components
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const BottomSheet = styled.div`
  background: linear-gradient(135deg, #fef7cd 0%, #fef3c7 50%, #fbbf24 100%);
  border-radius: 24px 24px 0 0;
  padding: 0;
  width: 100%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 -10px 40px rgba(251, 191, 36, 0.3);
  animation: ${slideUp} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: hidden;

  ${({ closing }) =>
    closing &&
    css`
      animation: ${slideDown} 0.3s ease-in forwards;
    `}
`;

const Handle = styled.div`
  width: 36px;
  height: 4px;
  background: #d97706;
  border-radius: 2px;
  margin: 12px auto 0;
  opacity: 0.7;
`;

const Confetti = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  pointer-events: none;
  overflow: hidden;
`;

const ConfettiPiece = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  background: ${({ index }) =>
    index === 0
      ? '#DC2626'
      : index === 1
        ? '#F59E0B'
        : index === 2
          ? '#10B981'
          : index === 3
            ? '#3B82F6'
            : index === 4
              ? '#8B5CF6'
              : index === 5
                ? '#EF4444'
                : index === 6
                  ? '#F97316'
                  : index === 7
                    ? '#06B6D4'
                    : '#84CC16'};
  border-radius: 50%;
  animation: ${confettiFall} 3s infinite ease-in-out;
  left: ${({ index }) => (index + 1) * 10}%;
  animation-delay: ${({ index }) => index * 0.3}s;
`;

const Content = styled.div`
  padding: 10px 24px 1px;
  position: relative;
`;

const FloatingEmojis = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  pointer-events: none;
`;

const FloatingEmoji = styled.div`
  position: absolute;
  font-size: 24px;
  animation: ${floatBounce} 2s infinite ease-in-out;

  &:nth-child(1) {
    top: 0;
    left: 10%;
    animation-delay: 0s;
  }

  &:nth-child(2) {
    top: 0;
    right: 15%;
    animation-delay: 0.5s;
  }

  &:nth-child(3) {
    top: 30px;
    left: 80%;
    animation-delay: 1s;
  }

  &:nth-child(4) {
    top: 5px;
    left: 60%;
    animation-delay: 1.5s;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 15px;
  margin-top: 15px;
  position: relative;
  z-index: 10;
`;

const Title = styled.div`
  font-size: 23px;
  font-weight: 600;
  background: linear-gradient(135deg, #dc2626 0%, #7c2d12 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 5px;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);

  white-space: nowrap; /* prevent wrapping */
  overflow: hidden; /* hide overflow if too long */
  text-overflow: ellipsis; /* show “…” when it overflows */
`;

const Emoji = styled.span`
  font-size: 36px;
  margin-right: 8px;
  animation: ${pulseBounce} 1.5s infinite;

  @media (max-width: 480px) {
    font-size: 30px;
  }
`;

const SurpriseBadge = styled.div`
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  margin-bottom: 24px;
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4);
  animation: ${glowPulse} 2s infinite;
`;

const OfferCard = styled.div`
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  border-radius: 20px;
  padding: 14px;
  margin-bottom: 14px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(220, 38, 38, 0.4);
  animation: ${cardGlow} 3s infinite;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.2) 0%,
      transparent 70%
    );
    animation: ${shimmer} 3s infinite linear;
  }

  &::after {
    content: '✨';
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 20px;
    animation: ${sparkle} 2s infinite;
  }
`;

const OfferMain = styled.div`
  font-size: 24px;
  font-weight: 900;
  margin-bottom: 8px;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const OfferDetail = styled.div`
  font-size: 17px;
  opacity: 0.95;
  margin-bottom: 1px;
  position: relative;
  z-index: 1;
  line-height: 1.4;
`;

const PriceSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  z-index: 1;
`;

const NewPrice = styled.div`
  font-size: 42px;
  font-weight: 900;
  color: #fef3c7;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
  animation: ${priceBounce} 2s infinite;

  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

const LottieWrapper = styled.div`
  position: relative; /* stay in normal flow but allow inner absolute */
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  background: 'white'; /* pushes the icon away from text below */
`;

const FloatingLottie = styled(Lottie)`
  position: relative;
  top: 200px; /* adjust this to move up (negative) or down (positive) */
  width: 400px !important; /* override inline if needed */
  height: 400px !important;
`;

const MotivationSub = styled.div`
  font-size: 14px;
  color: #92400e;
  font-weight: 600;
  margin-bottom: 6px;
`;

const Options = styled.div`
  margin-bottom: 7px;
`;

export default OfferModal;
